
export default [

    {
        x: 150,
        y: 0,
        z: 0,

        w: 160,
        h: 90,
        src: '/assets/img/home/hd/bg-ban1-r.jpg'
    },

    {
        x: 20,
        y: 100,
        z: -50,

        w: 160,
        h: 90,
        src: '/assets/img/home/hd/bg-ban1-l.jpg'
    },

    {
        x: -142,
        y: 145,
        z: -100,

        w: 160,
        h: 90,
        src: '/assets/img/home/md/bg-ban2.jpg'
    },

    {
        x: 10,
        y: -120,
        z: -125,

        w: 160,
        h: 180,
        src: '/assets/img/home/hd/bg-ban6-l.jpg'
    },

    {
        x: 165,
        y: 137,
        z: -250,

        w: 160,
        h: 180,
        src: '/assets/img/home/hd/bg-ban3-r.jpg'
    },

    {
        x: 45,
        y: -121,
        z: -305,

        w: 160,
        h: 90,
        src: '/assets/img/home/hd/bg-ban5-r.jpg'
    },

    {
        x: 0,
        y: 0,
        z: -355,

        w: 160,
        h: 90,
        src: '/assets/img/home/md/bg-ban4.jpg'
    },

    {
        x: -145,
        y: -117,
        z: -425,

        w: 160,
        h: 90,
        src: '/assets/img/home/hd/bg-ban5-l.jpg'
    },

    {
        x: -315,
        y: 0,
        z: -465,

        w: 160,
        h: 180,
        src: '/assets/img/home/hd/bg-ban6-r.jpg'
    },

    {
        x: -117,
        y: -175,
        z: -500,

        w: 160,
        h: 90,
        src: '/assets/img/home/hd/bg-ban7-tl.jpg'
    }
]
